"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateLevelFields = exports.getMissingMandatoryFields = exports.getMandatoryFields = exports.getAdditionalValidationFields = void 0;
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var getMandatoryFields = exports.getMandatoryFields = function getMandatoryFields() {
  return [{
    label: 'First Name',
    // this.t('First Name')
    name: 'firstName',
    type: 'text',
    validators: ['required']
  }, {
    label: 'Middle Name',
    // this.t('Middle Name')
    name: 'middleName',
    type: 'text',
    validators: []
  }, {
    label: 'Last Name',
    // this.t('Last Name')
    name: 'lastName',
    type: 'text',
    validators: ['required']
  }, {
    label: 'Date of Birth',
    // this.t('Date of Birth')
    name: 'dob',
    type: 'date',
    validators: ['required', 'isDate']
  }, {
    label: 'Billing Phone',
    // this.t('Billing Phone')
    name: 'phone',
    type: 'phone',
    validators: ['required']
  }, {
    label: 'Billing Country',
    // this.t('Billing Country')
    name: 'billingCountry',
    type: 'country',
    validators: ['required']
  }, {
    label: 'Billing Street Address',
    // this.t('Billing Street Address')
    name: 'billingStreetAddress',
    type: 'text',
    info: '(100 Washington Way)',
    // this.t('(100 Washington Way)')
    validators: ['required']
  }, {
    label: 'Billing State',
    // this.t('Billing State')
    name: 'state',
    type: 'text',
    info: 'Abbreviation only',
    validators: ['required']
  }, {
    label: 'Billing City',
    // this.t('Billing City')
    name: 'billingCity',
    type: 'text',
    validators: ['required']
  }, {
    label: 'Billing Zip',
    // this.t('Billing Zip')
    name: 'billingZip',
    type: 'text',
    validators: ['required', 'alphanumeric']
  }, {
    label: 'Type of ID you want to upload',
    // this.t('Type of ID you want to upload')
    name: 'DocumentType',
    type: 'select',
    options: {
      PP: 'Passport',
      // this.t('Passport'),
      DL: 'Drivers License',
      // this.t('Drivers License'),
      ID: 'Identity Card',
      // this.t('Identity Card'),
      RP: 'Residence Permit' // this.t('Residence Permit')
    },
    validators: ['required']
  }, {
    label: 'Document Country',
    // this.t('Document Country')
    name: 'DocumentCountry',
    type: 'country',
    validators: ['required']
  }, {
    label: 'Document State',
    // this.t('Document State')
    name: 'DocumentState',
    type: 'text',
    validators: ['required']
  }, {
    placeholder: 'Upload an image of your selected Document',
    // this.t('Upload an image of your selected Document')
    name: 'scandata',
    type: 'image',
    alt: 'Document',
    // this.t('Document')
    maxSize: 3.8,
    // Max Size supported by IM
    label: 'Document',
    // this.t('Document')
    validators: ['required']
  }, {
    placeholder: 'Image of the back of your Document',
    // this.t('Image of the back of your Drivers License')
    name: 'backsideimagedata',
    type: 'image',
    info: "Mandatory for driver's License",
    alt: 'Documents back',
    // this.t('Documents back')
    maxSize: 3.8,
    // Max Size supported by IM
    label: "Document's back",
    // this.t('Document\'s back')
    validators: ['required']
  }, {
    placeholder: 'Upload selfie',
    // this.t('Upload selfie')
    name: 'faceimages',
    label: 'Selfie',
    // this.t('Selfie')
    type: 'image',
    alt: 'Selfie picture',
    // this.t('Selfie picture')
    maxSize: 3.8,
    // Max Size supported by IM,
    validators: [],
    info: 'Optional - Uploading a selfie helps to verify your identity faster.' // this.t('Optional - Uplading a selfie helps to verify your identity faster.')
  }];
};
var iterateOnLevel = function iterateOnLevel(level, callbackFn) {
  if (level.steps) {
    level.steps.forEach(function (step) {
      step.sections.forEach(callbackFn);
    });
  } else {
    level.sections.forEach(callbackFn);
  }
};
var getAllConfigFields = function getAllConfigFields(levels) {
  var configFields = [];
  levels.forEach(function (level) {
    return iterateOnLevel(level, function (section) {
      configFields = [].concat(_toConsumableArray(configFields), _toConsumableArray(section.form || []));
    });
  });
  return configFields;
};
var getMissingMandatoryFields = exports.getMissingMandatoryFields = function getMissingMandatoryFields(levels) {
  var mandatoryFields = getMandatoryFields();
  var configFields = getAllConfigFields(levels);
  return mandatoryFields.filter(function (mandatoryField) {
    return !configFields.find(function (field) {
      return field.name === mandatoryField.name;
    });
  });
};
var updateLevelFields = exports.updateLevelFields = function updateLevelFields(level) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    suppressDefaultValidators: false
  };
  var mandatoryFields = getMandatoryFields();
  iterateOnLevel(level, function (section) {
    section.form.forEach(function (field) {
      var mandatoryField = mandatoryFields.find(function (f) {
        return f.name === field.name;
      });
      if (mandatoryField) {
        field.label = field.label || mandatoryField.label;
        field.info = field.info || mandatoryField.info;
        field.type = mandatoryField.type;
        if (!options.suppressDefaultValidators) {
          field.validators = field.validators ? _toConsumableArray(new Set([].concat(_toConsumableArray(field.validators), _toConsumableArray(mandatoryField.validators)))) : mandatoryField.validators;
        }
        if (isUploadField(mandatoryField.type)) {
          field.placeholder = field.placeholder || mandatoryField.placeholder;
          field.maxSize = mandatoryField.maxSize;
        }
        if (['select', 'country'].includes(field.type)) field.options = field.options || mandatoryField.options || [];
      }
    });
  });
};
var isUploadField = function isUploadField(field) {
  return ['image', 'document', 'upload'].includes(field.type);
};
var getAdditionalValidationFields = exports.getAdditionalValidationFields = function getAdditionalValidationFields(level) {
  var uploadFields = [];
  iterateOnLevel(level, function (section) {
    section.form.forEach(function (field) {
      if (isUploadField(field)) {
        uploadFields.push(field.name);
      }
    });
  });
  return uploadFields;
};